import { SortDirectionEnum, TagStatus, getEnumKey } from '@gripp/shared-logic';
import {
  textStyles,
  InfiniteDataGrid, SlideLayout, StatusBadge,
  StatusBadgeType
} from '@gripp/shared-ui';
import { createColumnHelper } from '@tanstack/react-table';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, Text, View } from 'react-native';
import { GET_TAGS } from '../operations/getTags';

export const Tags = () => {
  const [count, setCount] = useState<number>();

  const leftColumn = {
    title: 'tags.title',
    count,
    mainComponent: <TagsBase onItemsCountChange={setCount} />,
    disableScroll: true
  };

  return (
    <SlideLayout
      leftColumn={leftColumn}
    />
  );
};

type TagsBaseProps = {
  onItemsCountChange?: (count: number) => void;
};

const TagsBase = ({ onItemsCountChange }: TagsBaseProps) => {
  const { t } = useTranslation();
  const columnHelper = createColumnHelper();
  const columns = [
    columnHelper.accessor('status', {
      cell: (info) => {
        const enumStatus = info.getValue() as TagStatus;
        const badgeStatus = enumStatus as StatusBadgeType;

        return (
          <StatusBadge
            type={badgeStatus}
            text={getEnumKey(TagStatus, enumStatus)}
          />
        );
      },
      header: () => t('tags.status'),
      meta: { sortable: true },
    }),
    columnHelper.accessor('tagCode', {
      cell: (info) => <Text style={textStyles.default}>{info.getValue()}</Text>,
      header: () => t('tags.tagCode'),
      meta: { sortable: true },
    }),
    columnHelper.accessor('link', {
      cell: ({ row }) => {
        const original = row.original as any;
        return <Text style={textStyles.default}>{original.link?.linkData?.title}</Text>;
      },
      header: () => t('tags.assetName'),
    }),
    columnHelper.accessor('version', {
      cell: (info) => <Text style={textStyles.default}>{info.getValue()?.version}</Text>,
      header: () => t('tags.version'),
      meta: { sortable: true },
    }),
    columnHelper.accessor('updatedAt', {
      cell: (info) => <Text style={textStyles.default}>{info.getValue()}</Text>,
      header: () => t('tags.updatedAt'),
      meta: { sortable: true },
    }),
  ];

  return (
    <View
      style={styles.container}
    >
      <InfiniteDataGrid
        modelName="tag"
        query={GET_TAGS}
        orderBy={{
          field: 'updatedAt',
          order: SortDirectionEnum.Desc,
        }}
        pageSize={50}
        columns={columns}
        onItemsCountChange={onItemsCountChange}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    borderRadius: 0,
    overflow: 'hidden',
  },
});
